import axios from 'axios';
const URL_SIMBANGDA = 'https://simbangda.sumbarprov.go.id/integrated/api';
// const URL_EBAPPENDAIP = 'http://182.253.192.84:8556/API/2';
// const URL_PBJ = 'https://sipedal.sumbarprov.go.id/api';
// const BASE_URL = 'https://testing3.sumbarprov.go.id/dpservices';
const BASE_URL = 'https://admin-dashboard.sumbarprov.go.id';
// const BASE_URL = 'http://127.0.0.1:8000';

class Api {
  bappendaKey = 'bapenda@02#2022';
  PBJ_KEY = 'c230af71-8705-4868-bcc6-c1356b2c2902';

  async authentication(payload) {
    try {
      const { status, data } = await axios.post(`${BASE_URL}/api/auth`, payload);
      if (status === 200) return { data, error: null };
    } catch (error) {
      return {
        status: 'failed',
        error: error.message,
      };
    }
  }

  async getRealisasiBelanjaOPD(tahun = "") {
    try {
      tahun = "/"+tahun
      // if(tahun === "/2023"){ tahun = "" }

      const { status, data } = await axios.get(`${BASE_URL}/api/simbangda/getrealisasibelanjaopd${tahun}`);
      if (status === 200) return { ...data, error: null };
    } catch (error) {
      return {
        status: 'failed',
        error: error.message,
      };
    }
  }
  async getRealisasiBelanjaOPD_perbulan(bulan = "", tahun = "") {
    try {
      const { status, data } = await axios.get(`${URL_SIMBANGDA}/dashboard_pembangunan/data_opd?bulan=${bulan}&tahun=${tahun}`);
      if (status === 200) return { ...data, error: null };
    } catch (error) {
      return {
        status: 'failed',
        error: error.message,
      };
    }
  }

  async getgrafikSimbangda(idopd, tahun) {
    try {
      let url =
        typeof idopd !== 'undefined'
          ? `/api/simbangda/getgrafikpencapaianopd/${idopd}/${tahun}`
          : `/api/simbangda/getgrafikpencapaianopd`;
      url = `/api/simbangda/getgrafikpencapaianopd/${idopd}/${tahun}`
      const { status, data } = await axios.get(`${BASE_URL}${url}`);
      if (status === 200) return { ...data, error: null };
    } catch (error) {
      return {
        status: 'failed',
        error: error.message,
      };
    }
  }

  async getRealisasiBelanjaPerOPD(tahun) {
    try {
      tahun = "/"+tahun
      // if(tahun === "/2023"){ tahun = "" }
      const { status, data } = await axios.get(`${BASE_URL}/api/simbangda/getlistrealisasibelanjaopd${tahun}`);
      if (status === 200) return { ...data, error: null };
    } catch (error) {
      return {
        status: 'failed',
        error: error.message,
      };
    }
  }

  async getRealisasiKegiatanPerOPD(idopd, tahun) {
    try {
      tahun = "/"+tahun
      // if(tahun === "/2023"){ tahun = "" }
      const { status, data } = await axios.get(`${BASE_URL}/api/simbangda/getrealisasikegiatanopd/${idopd}${tahun}`);
      if (status === 200) return { ...data, error: null };
    } catch (error) {
      return {
        status: 'failed',
        error: error.message,
      };
    }
  }

  async getRealisasiProsesPbj(tahun) {
    try {
      let body = {
        tahun: tahun
      };
      const { status, data } = await axios.post(`${BASE_URL}/api/sipedal/getrealisasipbj`, body);
      if (status === 200) return { ...data, error: null };
    } catch (error) {
      return {
        status: 'failed',
        error: error.message,
      };
    }
  }

  async getPendapatanDaerah(tahun) {
    try {
      const { status, data } = await axios.get(`${BASE_URL}/api/bapenda/getpendapatan/${tahun}`);
      if (status === 200) return { data, error: null };
    } catch (error) {
      return {
        status: 'failed',
        error: error.message,
      };
    }
  }
  async getAllPendapatan(tahun) {
    try {
      const { status, data } = await axios.get(`${BASE_URL}/api/bapenda/getdetailpendapatan/${tahun}`);
      if (status === 200) return { data, error: null };
    } catch (error) {
      return {
        status: 'failed',
        error: error.message,
      };
    }
  }
  async getGrafikPendapatan(tahun) {
    try {
      const { status, data } = await axios.get(`${BASE_URL}/api/bapenda/getgrafikpendapatan/${tahun}`);
      if (status === 200) return { data, error: null };
    } catch (error) {
      return {
        status: 'failed',
        error: error.message,
      };
    }
  }

  async getRealisasiOpdPbj(type, tahun) {
    try {
      const { status, data } = await axios.post(`${BASE_URL}/api/sipedal/getrealisasiopd`, {
        tahun: tahun,
        jenis_transaksi: type,
      });
      if (status === 200) return { data, error: null };
    } catch (error) {
      return {
        status: 'failed',
        error: error.message,
      };
    }
  }
  async getDetailPaketOpdPbj(idsatker, tahun) {
    try {
      let body = {
        tahun: tahun,
        idsatker,
      };
      const { status, data } = await axios.post(`${BASE_URL}/api/sipedal/getrealisasipaket`, body);
      if (status === 200) return { data, error: null };
    } catch (error) {
      return {
        status: 'failed',
        error: error.message,
      };
    }
  }

  async getDataHibah(tahun) {
    try {
      const { status, data } = await axios.get(`${BASE_URL}/api/hibah/getdatahibah/${tahun}`);
      if (status === 200) return { data, error: null };
    } catch (error) {
      return {
        status: 'failed',
        error: error.message,
      };
    }
  }
  async getOpdPemberiHibah(tahun) {
    try {
      const { status, data } = await axios.get(`${BASE_URL}/api/hibah/getopdpemberihibah/${tahun}`);
      if (status === 200) return { data, error: null };
    } catch (error) {
      return {
        status: 'failed',
        error: error.message,
      };
    }
  }
  async getDetailHibahOpd(idOpd, tahun) {
    try {
      const { status, data } = await axios.get(`${BASE_URL}/api/hibah/getdetailhibahopd/${idOpd}/${tahun}`);
      if (status === 200) return { data, error: null };
    } catch (error) {
      return {
        status: 'failed',
        error: error.message,
      };
    }
  }

  async getListOpdIKD() {
    try {
      const { status, data } = await axios.get(`${BASE_URL}/api/indikator/getlistopd`);
      if (status === 200) return { data, error: null };
    } catch (error) {
      return {
        status: 'failed',
        error: error.message,
      };
    }
  }
  async getDataIkdOpd(idopd) {
    try {
      const { status, data } = await axios.get(`${BASE_URL}/api/indikator/getikd/${idopd}`);
      if (status === 200) return { data, error: null };
    } catch (error) {
      return {
        status: 'failed',
        error: error.message,
      };
    }
  }

  async getLayananIKP() {
    try {
      const { status, data } = await axios.get(`${BASE_URL}/api/indikator/getlayananikp`);
      if (status === 200) return { data, error: null };
    } catch (error) {
      return {
        status: 'failed',
        error: error.message,
      };
    }
  }
  
  async getDataIKP(idurusan) {
    try {
      const { status, data } = await axios.get(`${BASE_URL}/api/indikator/getikp/${idurusan}`);
      if (status === 200) return { data, error: null };
    } catch (error) {
      return {
        status: 'failed',
        error: error.message,
      };
    }
  }


  async getProgramUnggulan() {
    try {
      const { status, data } = await axios.get(`${BASE_URL}/api/indikator/getprogul`);
      if (status === 200) return { data, error: null };
    } catch (error) {
      return {
        status: 'failed',
        error: error.message,
      };
    }
  }
  async getDataProgul(idprogul) {
    try {
      const { status, data } = await axios.get(`${BASE_URL}/api/indikator/getdataprogul/${idprogul}`);
      if (status === 200) return { data, error: null };
    } catch (error) {
      return {
        status: 'failed',
        error: error.message,
      };
    }
  }

  async getListOPDPerjanjianKinerja() {
    try {
      const { status, data } = await axios.get(`https://sakip.sumbarprov.go.id/versi2023/mobile/data/getDataOPD`);
      if (status === 200) return { data, error: null };
    } catch (error) {
      return {
        status: 'failed',
        error: error.message,
      };
    }
  }
  async getCapaianPerjanjianKinerja(idopd, tanggal) {
    try {
      tanggal = tanggal != "" ? `&tanggal=${tanggal}` : ""
      const { status, data } = await axios.get(`https://sakip.sumbarprov.go.id/versi2023/mobile/data/getLaporanRealisasiOpd?id_opd=${idopd+tanggal}`);
      if (status === 200) return { data, error: null };
    } catch (error) {
      return {
        status: 'failed',
        error: error.message,
      };
    }
  }

  async getIndikatorKinerjaUtama() {
    try {
      const { status, data } = await axios.get(`${BASE_URL}/api/indikator/getiku`);
      if (status === 200) return { data, error: null };
    } catch (error) {
      return {
        status: 'failed',
        error: error.message,
      };
    }
  }

  async getStatsVisitors(){
    try {
      const { status, data } = await axios.get(`${BASE_URL}/api/visitors/counter`);
      if (status === 200) return { data, error: null };
    } catch (error) {
      return {
        status: 'failed',
        error: error.message,
      };
    }
  }

  async getCapaianPKGubernur(tahun = "") {
    try {
      tahun = tahun !== "" ? `?tahun=${tahun}` : ""
      const { status, data } = await axios.get(`https://sakip.sumbarprov.go.id/versi2023/mobile/data/getRealisasiPKGubernur${tahun}`);
      if (status === 200) return { data, error: null };
    } catch (error) {
      return {
        status: 'failed',
        error: error.message,
      };
    }
  }

}

export default Api;
